import React, { useState, useEffect } from "react";
import { Modal, Descriptions, Tag, Typography } from "antd";
import { getBelt, ListClass } from "../../constants/API/API";
import { ShowToast, Severty } from "../../helper/toast";
import useApi from "../../hooks/useApi";

const { Title } = Typography;
const BeltView = ({ viewVisible, setViewVisible, selectedBelt }) => {
  const [beltData, setBeltData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);

  useApi({
    callback: ListClass,
    dependencies: [],
    shouldCallApi: true,
    onSuccess: ({ list }) => setClasses(list),
  });

  useEffect(() => {
    if (selectedBelt) {
      setLoading(true);
      getBelt(selectedBelt._id)
        .then((response) => {
          if (response.status === 200 && response.data) {
            setBeltData(response.data);
          }
        })
        .catch((err) => {
          ShowToast(err.message || "Failed to fetch belt data", Severty.ERROR);
        })
        .finally(() => setLoading(false));
    }
  }, [selectedBelt]);

  const handleCancel = () => {
    setViewVisible(false);
    setBeltData(null);
  };

  return (
    <Modal
      open={viewVisible}
      title={<Title level={4} style={{ margin: 0 }}>Belt Details</Title>}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
      loading={loading}
    >
      {beltData && (
        <Descriptions
          bordered
          column={1}
          labelStyle={{
            fontWeight: 500,
            backgroundColor: "#fafafa",
            minWidth: "150px",
          }}
          contentStyle={{
            backgroundColor: "#fff",
          }}
        >
          <Descriptions.Item label="Belt Name">
            {beltData.name}
          </Descriptions.Item>
          <Descriptions.Item label="branch Name">
            {beltData.branchName}
          </Descriptions.Item>
          <Descriptions.Item label="Color Code">
            {Array.isArray(beltData.colorCode)
              ? beltData.colorCode.map((color, index) => (
                  <Tag key={index} color={color}>
                    {color}
                  </Tag>
                ))
              : beltData.colorCode && <Tag color={beltData.colorCode}>{beltData.colorCode}</Tag>}
          </Descriptions.Item>

          <Descriptions.Item label="Order">
            <Tag style={{ fontFamily: "monospace" }}>{beltData.order}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Stripe Count">
            <Tag style={{ fontFamily: "monospace" }}>{beltData.stripeCount}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Stripe Color Code">
            <Tag color={beltData.stripeColor}>{beltData.stripeColor}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Belt Level">
            <Tag>{beltData.beltLevel}</Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Growth Prompt Type">
            <Tag color="blue">{beltData.GrowthPromptType}</Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Review Link">
            <a href={beltData.reviewLink} target="_blank" rel="noreferrer">
              {beltData.reviewLink}
            </a>
          </Descriptions.Item>
          <Descriptions.Item label="Branch Name">
            {beltData.branchName}
          </Descriptions.Item>
          <Descriptions.Item label="Message">
            <div style={{ whiteSpace: "pre-line" }}>
              {beltData.message}
            </div>
          </Descriptions.Item>

          <Descriptions.Item label="Created At">
            {new Date(beltData.createdAt).toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={beltData.isActive ? "success" : "error"}>
              {beltData.isActive ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  );
};

export default BeltView;